// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".item-block-body[data-v-d5028edc]{display:flex;flex-wrap:wrap;font-size:14px}.item-block-body .mt[data-v-d5028edc]{padding:6px 0}.item-block-body .tr[data-v-d5028edc]{display:flex;width:100%}.item-block-body .tr .th[data-v-d5028edc]{min-width:80px;width:80px}.item-block-body .tr .td[data-v-d5028edc]{color:#555;width:100%}.area-objects-create[data-v-d5028edc]{display:flex;flex-wrap:wrap;max-height:80px;overflow-y:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
